import { render } from "./SubCategoryAdd.vue?vue&type=template&id=1c0d9e28"
import script from "./SubCategoryAdd.vue?vue&type=script&lang=js"
export * from "./SubCategoryAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__